import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { Fragment, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SINGLE_USER_PERMISSIONS } from "../../../../../../enums/UrlPaths";
import { ThemeContext } from "../../../../../../contexts/ThemeContext";

const ClinicsUsersTable = ({ users }) => {
  const navigate = useNavigate();
  const minUsers = 10;
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(minUsers);
  const { mode } = useContext(ThemeContext);
  const bgColorOfRow = mode == "dark" ? "black" : "#f5f3f4";

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, minUsers));
    setPage(0);
  };

  const handleRowClick = (id) => {
    navigate(`${SINGLE_USER_PERMISSIONS}${id}`);
  };

  return (
    <Fragment>
      <Table aria-label="user table" size="medium">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("LastName")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users
              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((user, index) => (
                <TableRow
                  key={user?.id}
                  hover
                  style={{
                    cursor: "pointer",
                    padding: "16px 8px",
                    backgroundColor: index % 2 == 0 ? bgColorOfRow : "",
                  }}
                  onClick={() => handleRowClick(user?.id)}
                >
                  <TableCell>{user?.id}</TableCell>
                  <TableCell>{user?.userDetails?.firstName}</TableCell>
                  <TableCell>{user.userDetails.lastName ? user.userDetails.lastName : ""}</TableCell>
                </TableRow>
              ))}
          </TableBody>
      </Table>
      {users?.length >= minUsers ? (
        <TablePagination
          rowsPerPageOptions={[minUsers, 25, 50]}
          component="div"
          count={users?.length}
          labelRowsPerPage={t("RowsPerPage")}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          backIconButtonProps={{
            title: t("PreviousPage"),
            "aria-label": t("PreviousPage"),
          }}
          nextIconButtonProps={{
            title: t("NextPage"),
            "aria-label": t("NextPage"),
          }}
        />
      ) : null}
    </Fragment>
  );
};

export default ClinicsUsersTable;
